import { Select } from "@commonlibs";
import styled from "styled-components";

export const PhoneCountryCodeSelectRoot = styled(Select)(() => ({
    width: 112,
})) as typeof Select;
